import React, { FC, ReactNode } from 'react'
import card from 'styles/components/card.module.scss'

type Props = {
  align?: 'left' | 'center' | 'right'
  children: ReactNode
}

const CardInner: FC<Props> = (props) => {
  const { children, align } = props
  return (
    <div className={card.basic__inner} style={{ textAlign: align ?? 'left' }}>
      {children}
    </div>
  )
}

export default CardInner
